import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { BreadCrumb } from "@kunduz/ui";
import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { getQIUrl } from "@kunduz/utility-common";

export const QISUGBreadcrumb = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");

  function prepareBase() {
    return {
      label: t("question_indexing_breadcrumb_1st_item_label"),
      url: `/`,
    };
  }

  function calculateItems() {
    const result: {
      label: string;
      url?: string;
      onClick?: () => void;
    }[] = [
      {
        label: t("question_indexing_breadcrumb_courses_label"),
        ...(Object.keys(props).length !== 1 && {
          url: getQIUrl({ lang: props.lang }),
        }),
      },
    ];

    if (props.question) {
      const _course = props.courses?.find(
        (c) => c.id == props.question.course_id,
      );
      if (props.question?.course) {
        result.push({
          label: _course?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: _course?.slug,
          }),
        });
      }
      if (props.question?.subject) {
        const _subject = _course?.subjects?.find(
          (s) => s.id == props.question.subject_id,
        );
        result.push({
          label: _subject?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: _course?.slug,
            subjectSlug: _subject?.slug,
          }),
        });
      }
      if (props.question?.text_content) {
        result.push({
          label: `${props.question?.text_content?.substring(0, 48)}...`,
        });
      }
    } else if (props.subject) {
      if (props.course) {
        result.push({
          label: props.course?.name,
          url: getQIUrl({
            lang: props.lang,
            courseSlug: props.course?.slug,
          }),
        });
      }
      if (props.subject) {
        result.push({
          label: props.subject?.name,
        });
      }
    } else if (props.course) {
      result.push({
        label: props.course?.name,
      });
    }

    return result.filter((x) => x.label);
  }

  return (
    <BreadCrumb
      base={prepareBase()}
      items={calculateItems()}
      linkAs={props.linkAs}
    />
  );
};

interface Props {
  question?: QuestionIndexing.UsQiQuestion;
  course?: any;
  subject?: any;
  lang: "tr" | "en";
  courses?: any[];
  linkAs?: React.ElementType;
}
